import { render, staticRenderFns } from "./BtnDetalhar.vue?vue&type=template&id=1bcdcbfb&"
import script from "./BtnDetalhar.vue?vue&type=script&lang=js&"
export * from "./BtnDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports